import BlockTitle from './BlockTitle.tsx';
import {RichBlockComponentProps} from './blockComponents.tsx';
import {Typography} from '@mui/material';
import nl2br from 'react-nl2br';
import {getBestTranslatedValue} from '../../../lib/localeHelper.ts';
import {TextBlockData} from '../../../types/api.ts';

export default function TextBlock({
    data: {title, text, translations},
    locale,
    userLocales,
}: RichBlockComponentProps<TextBlockData>) {
    const resolvedTitle = getBestTranslatedValue(
        translations ?? {},
        'title',
        title,
        locale,
        userLocales,
    );
    const resolvedText = getBestTranslatedValue(
        translations ?? {},
        'text',
        text,
        locale,
        userLocales,
    );

    return (
        <>
            <BlockTitle title={resolvedTitle} />
            <Typography variant={'body1'} component="p">
                {nl2br(resolvedText)}
            </Typography>
        </>
    );
}
